/** Activity log page and its drawer. */
export const activity = {
  title: "Activity",
  intro: "Who did what and when, for this brand plus organization-wide changes (team, roles, settings). This log can't be edited.",
  noAccessTitle: "You don't have access to the activity log",
  noAccessBody: "Ask an owner if you need it.",
  caption: "Activity log",
  rowLabel: "{action} by {actor}",
  emptyTitle: "No activity in this period",
  whatChanged: "What changed",

  // Columns and drawer details
  time: "Time",
  who: "Who",
  when: "When",
  action: "Action",
  target: "Target",
  ip: "IP",
  targetId: "Target ID",

  /** One-line context in the list. */
  quote: "“{text}”",
  seeChanges: "see changes",

  // Value formatting in the details and the before → after table
  orgList: "organization's list",
  none: "none",
  allBrands: "All brands",
  selectedBrands: "Selected brands",
  emptyAnyNetwork: "empty (any network)",
  yes: "yes",
  no: "no",
  added: "Added",
  removed: "Removed",
  noChanges: "No changes.",

  /** Field names in the before → after table. */
  fields: {
    role: "Role",
    all_merchants: "Scope",
    merchant_ids: "Brands",
    permissions: "Permissions",
    name: "Name",
    description: "Description",
    value: "List",
  },

  /** Labels for extra detail keys in the drawer; unknown keys show the key with spaces. */
  detailKeys: {
    reason: "reason",
    email: "email",
    url: "url",
    role: "role",
    payouts: "payouts",
    failed: "failed",
    from: "from",
    all_merchants: "all merchants",
    merchant_ids: "merchant ids",
    telegram_user_id: "telegram user id",
  },

  /** Target types (API codes as keys). */
  targets: {
    payout: "Payout",
    api_key: "API key",
    console_user: "Member",
    user: "Member",
    console_invite: "Invite",
    invite: "Invite",
    webhook: "Webhook",
    webhook_event: "Webhook event",
    session: "Session",
    deposit: "Deposit",
    console_role: "Role",
    organization: "Organization",
    merchant: "Brand",
  },

  /** Audit actions (API codes as keys); unknown actions show the code as words. */
  actions: {
    login: "Logged in",
    "login.failed": "Failed login attempt",
    "login.ip_blocked": "Login blocked: network not allowed",
    logout: "Logged out",
    "merchant.switch": "Switched brand",
    "mfa.enroll": "Turned on two-step verification",
    "mfa.reset_accept": "Reset two-step verification",
    "mfa.reset": "Two-step verification was reset",
    "invite.accept": "Joined the organization",
    "payout.create": "Created a payout",
    "payout.approve": "Approved a payout",
    "payout.reject": "Rejected a payout",
    "payout.approve_telegram": "Approved a payout in Telegram",
    "payout.reject_telegram": "Rejected a payout in Telegram",
    "api_key.create": "Created an API key",
    "api_key.revoke": "Revoked an API key",
    "api_key.reveal": "Viewed an API key's secret",
    "api_key.ip_allowlist": "Changed an API key's server IPs",
    "api_key.ip_change": "Changed an API key's server IPs",
    "webhook.set": "Changed the webhook URL",
    "webhook.resend": "Resent a webhook event",
    "team.invite": "Invited a team member",
    "team.invite_cancel": "Cancelled an invite",
    "team.member_change": "Changed a member's role or brands",
    "team.disable": "Disabled a member",
    "team.ip_allowlist": "Changed a member's console IP list",
    "role.create": "Created a role",
    "role.change": "Changed a role",
    "role.delete": "Deleted a role",
    "settings.console_ip": "Changed the console IP allowlist",
    "settings.telegram_approval": "Changed Telegram approval settings",
    "telegram.link": "Linked Telegram",
    "telegram.unlink": "Unlinked Telegram",
    "password.change": "Changed their password",
    "session.revoke": "Ended a session",
    "organization.add_brand": "Added a brand",
    "user.disable": "Login disabled by iCryptoNow",
  },
};
